import { TimelineItems, TimeLines } from '../../../components/AwardsAndAccoladesTimelines/types/propsTypes';
import type { AwardsAndAccoladesTimelinesProps } from '../../../components/AwardsAndAccoladesTimelines/AwardsAndAccoladesTimelines';
import { ComponentType } from '../../registries/types/propTypes';
import { CMSTransformerDataType } from '../../types/common';
const transformAwardsTimelines = (data: CMSTransformerDataType): AwardsAndAccoladesTimelinesProps => {
  const { aboutAmwayAwards, year } = data;
  const timelines: TimeLines[] = [];
  const timelineItems: TimelineItems[] = [];
  aboutAmwayAwards?.timelines?.forEach((timeline: { events: CMSTransformerDataType[] }) => {
    const mappedArr = timeline.events.map((item) => ({
      description: item.description,
      images: item.image.images,
      title: item.title,
    }));
    timelineItems.push({
      year: timeline.events[0].year,
      data: mappedArr,
    });
    timelines.push({
      title: timeline.events[0].year,
      id: timeline.events[0].year,
    });
  });
  return {
    componentType: ComponentType.awards_timelines,
    timelines: timelines,
    timelineItems: timelineItems,
    activeTabId: data.activeTabId,
    callBack: data.callBack,
    year: year,
  };
};

export default transformAwardsTimelines;
